module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    lightblue: '#00AFCB',
                    lighterblue: '#66BED8',
                    lightestblue: '#eff8fb',
                    blue: '#0093BE',
                    darkblue: '#0A718B',
                    darkishblue: '#33A9CB',
                    grayishblue: '#227F97',
                    grayishlighterbue: '#328a9e',
                    darkgray: '#4B5563',
                    gray: '#9CA3AF',
                    green: '#50B49B',
                    orange: '#F18F03',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/Http/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/*.{vue,js,scss,php}',
    ],
};
